export enum Team_NAMES {
  Dragons,
  Titans,
  Roosters,
  Broncos,
  Knights,
  Eels,
  Panthers,
  "Sea Eagles",
  Raiders,
  Sharks,
  Rabbitohs,
  Warriors,
  Tigers,
  "Wests Tigers",
  Storm,
  Cowboys,
  Bulldogs,
  Dolphins,
}
